/* globals _ */

import View from './base';

const { extend } = _;

export default View.extend( {
	map: null,
	objClass: null,
	isVisible: true,
	isFocused: false,
	isSelected: false,

	listeners: extend( {}, View.prototype.listeners, {
		'model change': 'maybeUpdatePosition',
	} ),

	_createElement: function() {
		return new this.objClass( { className: this.className });
	},

	_setElement: function( el ) {
		this.el = el;

		this.el.addListener( 'click', () => {
			this.trigger( 'select' );
		} );
	},

	_removeElement: function() {
		if ( this.el ) {
			this.el.setMap( null );
		}
	},

	_setAttributes: function() { /* do nothing */ },

	findElements: function() {},

	delegate: function( event, selector, listener ) {
		if ( typeof selector === 'function' ) {
			listener = selector;
			selector = null;
		}

		this.listeners.push( this.el.addListener( event, listener ) );
	},

	preinitialize: function( options = {} ) {
		this.defaults = options.defaults || null;
		this.objClass = options.objClass || null;
		this.map = options.map || null;

		if ( typeof options.visible !== 'undefined' ) {
			this.isVisible = Boolean( options.visible );
		}
	},

	maybeUpdatePosition: function() {
		if ( this.model.changed.lat || this.model.changed.lng ) {
			this.el.setPosition( {
				lat: this.model.get( 'lat' ),
				lng: this.model.get( 'lng' ),
			} );
		}
	},

	render: function( focused ) {
		if ( typeof focused === 'undefined' ) {
			focused = this.isFocused || this.isSelected;
		}

		if ( this.el ) {
			this.el.setVisible( this.isVisible );
			this.el.setZIndex( focused ? 1 : 0 );

			if ( ! this.el.getMap() ) {
				this.el.setMap( this.map );
			}

			this.el.setPosition( {
				lat: this.model.get( 'lat' ) || 0,
				lng: this.model.get( 'lng' ) || 0,
			} );

			var category = this.model.getAttributeObject( 'category' );
			if ( category ) {
				this.el.div_.setAttribute( 'data-category', category.get( 'slug' ) );
			}

			this.el.toggleClass( 'is-event', this.model.get( 'isEvent' ) );
		}

		return this;
	},

	maybeRerender: function() {
		if ( this.isVisible ) {
			this.render();
		}
	},

	show: function() {
		this.isVisible = true;

		if ( this.el ) {
			this.el.setVisible( true );
		}

		return this;
	},

	hide: function() {
		this.isVisible = false;

		if ( this.el ) {
			this.el.setVisible( false );
		}

		return this;
	},
} );
